/**
 * Helpers para las acciones del chat (botones ver/confirmar).
 */
import { ChatAction } from '../types/chat';

/**
 * Firma estable de una acción del chat para detectar duplicados EXACTOS.
 * Incluye tipo, label y la selección (ver) o el pending_op_id (confirmar), así que
 * solo colapsa acciones idénticas; nunca junta acciones distintas (p. ej. dos
 * selecciones con distinto selection_id se mantienen).
 */
function actionSignature(a: ChatAction): string {
  if (a.tipo === 'ver') {
    return JSON.stringify({ tipo: a.tipo, label: a.label, target: a.target, seleccion: a.seleccion });
  }
  if (a.tipo === 'ver_recurso') {
    return JSON.stringify({ tipo: a.tipo, label: a.label, target: a.target });
  }
  // confirmar
  return JSON.stringify({ tipo: a.tipo, label: a.label, pending_op_id: a.pending_op_id });
}

/**
 * Quita acciones duplicadas exactas, preservando el orden y la primera aparición.
 * Defensa frente a un backend que a veces emite acciones repetidas en el evento
 * `done` (p. ej. dos botones "Revisar" idénticos).
 */
export function dedupeChatActions(actions: ChatAction[] | undefined | null): ChatAction[] {
  if (!actions || actions.length === 0) return [];
  const seen = new Set<string>();
  const result: ChatAction[] = [];
  for (const a of actions) {
    const sig = actionSignature(a);
    if (!seen.has(sig)) {
      seen.add(sig);
      result.push(a);
    }
  }
  return result;
}
